<template>
<div id="contents">

  <div id="works" class="page_contents">

    <div id="works_contents">
      <div id="works_archive_index">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/works/program/title.png" width="225" alt="WORKS" />
            <span>制作実績</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <worksPageNav/>

        <div id="works_archive_index_body">
          <div id="works_archive_index_about">
            <h2>アーカイブ検索サイト終了のお知らせ</h2>
            <div id="works_archive_index_about_inner">
              <div>
                <p style="margin-bottom: 15px;">テレビ朝日映像アーカイブ検索サイトの終了についてご連絡いたします。</p>
                <p style="margin-bottom: 15px;">このサイトは開設以来、多くの方々にご利用いただいておりましたが、2025年12月23日(火)をもちまして終了させていただきました。<br />これまでの皆様のご愛顧に、深く感謝申し上げますとともに、心より御礼申し上げます。</p>
                <p style="margin-bottom: 15px;">『テレビ朝日映像アーカイブ』の問い合わせは、下記のメールアドレスまでお願い致します。<br />メール：archive@tv-asahipro.co.jp</p>
                <p style="margin-bottom: 15px;" v-if="after_target_time">『朝日新聞フォトアーカイブ』への連絡先は下記の通りです。<br />電 話：03-5541-8138（受付時間：平日10時～20時）<br />メール：shashin@asahi.com<br />HP：https://photoarchives.asahi.com/</p>
                <p style="margin-bottom: 15px;" v-else>『朝日新聞フォトアーカイブ』への連絡先は下記の通りです。<br />電 話：03-5541-8138（受付時間：平日10時～18時）<br />メール：shashin@asahi.com<br />HP：https://photoarchives.asahi.com/</p>
              </div>
            </div><!-- #works_archive_index_about_inner -->
          </div><!-- #works_archive_index_about -->

        </div><!-- #works_archive_index_body -->

      </div><!-- #works_archive_index -->
    </div><!-- #works_contents -->
  </div><!-- #works -->



</div><!-- #contents -->
</template>

<script>
import worksPageNav from './shared/worksPageNav.vue'
export default {
  name: 'video-archive_index',
  components: {
    worksPageNav
  },
  computed: {
    after_target_time() {
      const targetDate = new Date('2026-06-01T00:00:00+09:00')
      const today = new Date()
      return today < targetDate
    }
  },
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)

    var obj = document.getElementById("sample");
    $("#archive_top_movie").css("display", "none");
    $('#sample_thumbnail').click(function () {
        $('#sample_thumbnail').hide();
        $('#archive_top_movie').fadeIn();
        obj.play();
    });
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/archive_index.vue